import Vue from 'vue'
import Vuex from 'vuex'
import pkg from 'package'
import createPersistedState from 'vuex-persistedstate'
import * as actions from './actions'
import * as getters from './getters'

import app from './modules/app'
import menu from './modules/menu'
import dialogs from './modules/dialogs'
import variables from './modules/variables'
import inventarisatie from './modules/inventarisatie'
import vscp from './modules/vscp'
import projectmanagement from './modules/projectmanagement'
import management from './modules/management'
import vastgoed from './modules/vastgoed'
import maritime from './modules/maritime'
import ihmRegister from './modules/ihm_register'
import rapportage from './modules/rapportage'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu,
    dialogs,
    variables,
    inventarisatie,
    vscp,
    vastgoed,
    maritime,
    projectmanagement,
    management,
    rapportage,
    ihmRegister
  },
  state: {
    pkg
  },
  mutations: {
  },
  plugins: [createPersistedState({
    paths: [
      'variables',
      'app',
      'vastgoed.assets',
      'projectmanagement.projecten', 'projectmanagement.onderzoeken',
      'management'
    ]
  })]
})

export default store
